/*
 * Simple Cart Auto-Update Functionality
 * Automatically updates cart quantities on change
 */

(function($) {
  'use strict';

  $(document).ready(function() {
    initCartAutoUpdate();
  });

  function initCartAutoUpdate() {
    // Cart quantity auto-update
    $(document).on('change', '.auto-update-qty', function() {
      var $input = $(this);
      var $cartItem = $input.closest('.cart_item');
      var line = $input.data('line');
      var quantity = parseInt($input.val()) || 0;
      
      // Validate quantity
      if (quantity < 0) {
        quantity = 0;
        $input.val(0);
      }
      
      // Show loading state
      $cartItem.addClass('updating');
      
      // Update cart via AJAX
      updateCartItem(line, quantity, function(cart) {
        // Success callback
        $cartItem.removeClass('updating');
        
        if (quantity === 0) {
          // Remove item from DOM if quantity is 0
          $cartItem.fadeOut(300, function() {
            $(this).remove();
            
            // Check if cart is now empty
            if (cart.item_count === 0) {
              location.reload(); // Reload to show empty cart state
            }
          });
        } else {
          // Update line total
          var lineTotal = cart.items[line - 1].line_price;
          $cartItem.find('.cart-item-total').html(formatMoney(lineTotal));
        }
        
        // Update cart totals
        updateCartTotals(cart);
        
      }, function(error) {
        // Error callback
        console.error('Cart update failed:', error);
        $cartItem.removeClass('updating');
        
        // Show error message
        showNotification('Failed to update cart. Please try again.', 'error');
        
        // Revert input value
        $input.val($input.data('original-value') || 1);
      });
    });
    
    // Store original values for error handling
    $('.auto-update-qty').each(function() {
      $(this).data('original-value', $(this).val());
    });
    
    // Update original value when successfully changed
    $(document).on('change', '.auto-update-qty', function() {
      var $this = $(this);
      setTimeout(function() {
        $this.data('original-value', $this.val());
      }, 1000);
    });
  }
  
  function updateCartItem(line, quantity, successCallback, errorCallback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line,
        quantity: quantity
      },
      dataType: 'json',
      success: function(cart) {
        if (successCallback) successCallback(cart);
      },
      error: function(xhr, status, error) {
        if (errorCallback) errorCallback(error);
      }
    });
  }
  
  function updateCartTotals(cart) {
    // Update cart count in header
    $('.cart-count, .cart_count').text(cart.item_count);
    
    // Update cart subtotal
    $('.cart-subtotal, .cart_subtotal').html(formatMoney(cart.total_price));
    
    // Hide cart count if empty
    if (cart.item_count === 0) {
      $('.cart-count, .cart_count').addClass('hidden');
    } else {
      $('.cart-count, .cart_count').removeClass('hidden');
    }
  }
  
  function formatMoney(cents) {
    // Use global money format if available
    if (window.moneyFormat) {
      return window.moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2));
    }
    // Fallback format
    return '$' + (cents / 100).toFixed(2);
  }
  
  function showNotification(message, type) {
    var $notification = $('<div class="cart-notification ' + type + '">' + message + '</div>');
    
    $('body').append($notification);
    
    // Auto-remove after 3 seconds
    setTimeout(function() {
      $notification.fadeOut(300, function() {
        $(this).remove();
      });
    }, 3000);
  }

})(jQuery);
